import React from 'react';
import Dialog, {
	DialogTitle,
	DialogContent,
	DialogActions,
} from '../common/Dialog';
import Button from '../common/buttons/Button';
import { Typography } from '@mui/material';
import { CompanyExternalUser } from '../../data/models/companyExternalUser';
import Modal from '../common/Modal';

interface ArchiveExternalUserConfirmationModalProps {
	open: boolean;
	handleClose: () => void;
	user?: CompanyExternalUser;
	users?: CompanyExternalUser[];
	onConfirm: () => void;
}

const ArchiveExternalUserConfirmationModal: React.FC<
	ArchiveExternalUserConfirmationModalProps
> = ({ open, handleClose, user, users, onConfirm }) => {
	// If neither user nor users are provided, don't render
	if (!user && (!users || users.length === 0)) return null;

	const isBulkAction = !user && users && users.length > 0;
	const userCount = isBulkAction ? users!.length : 1;

	const handleConfirm = () => {
		onConfirm();
		handleClose();
	};

	return (
		<Modal open={open} handleClose={handleClose}>
			<DialogTitle>
				Archive External {isBulkAction ? 'Users' : 'User'}
			</DialogTitle>
			<DialogContent>
				<Typography variant="body1" gutterBottom>
					{isBulkAction ? (
						<>
							Are you sure you want to archive{' '}
							<strong>{userCount} selected users</strong>?
						</>
					) : (
						<>
							Are you sure you want to archive{' '}
							<strong>
								{user!.firstName} {user!.lastName}
							</strong>{' '}
							({user!.email})?
						</>
					)}
				</Typography>
				<Typography
					variant="body2"
					color="text.secondary"
					sx={{ mt: 2 }}
				>
					Archiving{' '}
					{isBulkAction
						? 'these external users'
						: 'this external user'}{' '}
					will:
				</Typography>
				<Typography
					component="ul"
					variant="body2"
					color="text.secondary"
					sx={{ mt: 1, pl: 2 }}
				>
					<li>Remove them from all groups</li>
					<li>Prevent them from being added to new projects</li>
					<li>Disable any existing invitation links</li>
				</Typography>
				<Typography
					variant="body2"
					color="warning.main"
					sx={{ mt: 2, fontWeight: 'medium' }}
				>
					This action can be reversed by unarchiving the{' '}
					{isBulkAction ? 'users' : 'user'}.
				</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose} variant="text" color="inherit">
					Cancel
				</Button>
				<Button
					onClick={handleConfirm}
					variant="contained"
					color="error"
				>
					Archive {isBulkAction ? 'Users' : 'User'}
				</Button>
			</DialogActions>
		</Modal>
	);
};

export default ArchiveExternalUserConfirmationModal;
